export default __webpack_public_path__ + "static/media/fierytorment.8f9f4ed2.png";